import React, { Component } from 'react';
import { Form, Row, Col, DropdownButton, Dropdown, InputGroup, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { getAdvancedResult } from '../../actions/searchActions';
import searchVars from "../../searchVar.json";
import categoriesJSON from "../../assets/rides/rideCategories.json";

const TILE_PER_PAGE = searchVars.TILE_PER_PAGE;

class AdvancedSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            distance: 50,
            sortBy: {
                label: "Distance",
                value: undefined
            },
            captainIncluded: true,
            captainNotIncluded: true,
            type: { label: "Tout", value: "all" },
            subType: { label: "Tout", value: "all" },
            disableDistance: false,
            subTypes: []
        }
    }

    onDistanceChange(data) {
        this.setState({
            distance: data.target.value
        })
    }

    onSortByChange(evt) {
        if (evt === "0") {
            this.setState({
                sortBy: { label: "Distance", value: undefined },
                disableDistance: false
            })
        }
        else if (evt === "1") {
            this.setState({
                sortBy: { label: "Prix: Haut à Bas", value: true },
                disableDistance: true
            })
        }
        else {
            this.setState({
                sortBy: { label: "Prix: Bas à Haut", value: false },
                disableDistance: true
            })
        }
    }

    capIncludedChange(data) {
        this.setState({
            captainIncluded: !this.state.captainIncluded
        })
    }

    capNotIncludedChange(data) {
        this.setState({
            captainNotIncluded: !this.state.captainNotIncluded
        })
    }

    onTypeChange(eventKey) {
        if (eventKey === "all") {
            this.setState({
                type: { label: "Tout", value: "all" },
                subType: { label: "Tout", value: "all" },
                subTypes: []
            })
        } else {
            const selectedCategory = categoriesJSON.categories.find(c => c.category.value === eventKey);
            if (selectedCategory) {
                this.setState({
                    type: { label: selectedCategory.category.showFr, value: selectedCategory.category.value },
                    subType: { label: "Tout", value: "all" },
                    subTypes: selectedCategory.types
                })
            }
        }
    }

    onSubTypeChange(eventKey) {
        if (eventKey === "all") {
            this.setState({
                subType: { label: "Tout", value: "all" }
            })
        } else {
            const selectedType = this.state.subTypes.find(t => t.value === eventKey);
            if (selectedType) {
                this.setState({
                    subType: { label: selectedType.showFr, value: selectedType.value }
                })
            }
        }
    }

    handleSubmit(evt) {
        evt.preventDefault();
        if (this.props.search && this.props.search.searchAddress) {
            geocodeByAddress(this.props.search.searchAddress).then((info) => {
                getLatLng(info[0]).then((res) => {
                    const searchInfos = {
                        latitude: res.lat,
                        longitude: res.lng,
                        page: 1,
                        elementPerPage: TILE_PER_PAGE
                    }

                    // Handle distance and sorting
                    if (this.state.sortBy.value !== undefined) {
                        // Sorting by price
                        searchInfos.upToDown = this.state.sortBy.value;
                        searchInfos.dist = this.state.distance || 50;
                    }
                    else {
                        // Sorting by distance
                        searchInfos.dist = this.state.distance || 50;
                    }

                    // Handle captain filter
                    if (this.state.captainIncluded && !this.state.captainNotIncluded) {
                        searchInfos.isCaptain = "true";
                    }
                    else if (!this.state.captainIncluded && this.state.captainNotIncluded) {
                        searchInfos.isCaptain = "false";
                    }

                    // Handle Categories
                    if (this.state.type.value !== "all") {
                        searchInfos.typeGroup = this.state.type.value;
                    }
                    if (this.state.subType.value !== "all") {
                        searchInfos.type = this.state.subType.value;
                    }

                    getAdvancedResult(searchInfos)
                })
            })
        }
    }

    render() {
        return (
            <div className="advancedSearch__bar">
                <h4 className="rides-tagline tileList__title">Filtres de recherche</h4>
                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <Row>
                        <Col>
                            <DropdownButton
                                id="dropdown-basic-button"
                                title={this.state.sortBy.label}
                                onSelect={this.onSortByChange.bind(this)}
                                className="w-100"
                            >
                                <Dropdown.Item eventKey={0}>Distance</Dropdown.Item>
                                <Dropdown.Item eventKey={1}>Prix: Haut à Bas</Dropdown.Item>
                                <Dropdown.Item eventKey={2}>Prix: Bas à Haut</Dropdown.Item>
                            </DropdownButton>
                        </Col>
                        <Col>
                            <InputGroup>
                                <InputGroup.Prepend>
                                    <InputGroup.Text id="inputGroupPrepend">Distance (km)</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                    type="number"
                                    name="distance"
                                    placeholder="(km)"
                                    value={this.state.distance}
                                    disabled={this.state.disableDistance}
                                    onChange={this.onDistanceChange.bind(this)}
                                    required
                                />
                            </InputGroup>
                        </Col>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                label="Avec Capitaine"
                                onChange={this.capIncludedChange.bind(this)}
                                checked={this.state.captainIncluded}
                            />
                            <Form.Check
                                type="checkbox"
                                label="Sans Captaine"
                                onChange={this.capNotIncludedChange.bind(this)}
                                checked={this.state.captainNotIncluded}
                            />
                        </Col>
                        <Col>
                            <DropdownButton
                                id="dropdown-type-button"
                                title={this.state.type.label}
                                onSelect={this.onTypeChange.bind(this)}
                                className="w-100"
                            >
                                <Dropdown.Item eventKey="all">Tout</Dropdown.Item>
                                {categoriesJSON.categories.map((cat, i) => (
                                    <Dropdown.Item key={i} eventKey={cat.category.value}>{cat.category.showFr}</Dropdown.Item>
                                ))}
                            </DropdownButton>
                        </Col>
                        <Col>
                            <DropdownButton
                                id="dropdown-subtype-button"
                                title={this.state.subType.label}
                                onSelect={this.onSubTypeChange.bind(this)}
                                className="w-100"
                                disabled={this.state.subTypes.length === 0}
                            >
                                <Dropdown.Item eventKey="all">Tout</Dropdown.Item>
                                {this.state.subTypes.map((type, i) => (
                                    <Dropdown.Item key={i} eventKey={type.value}>{type.showFr}</Dropdown.Item>
                                ))}
                            </DropdownButton>
                        </Col>
                        <Col>
                            <Button type="submit">Recherche</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

export default connect((state) => {
    return { search: state.reducerSearchResult }
})(AdvancedSearch);